import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComprasComponent } from './pages/compras/compras.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { ProductoComponent } from './pages/producto/producto.component';
import { ProductosComponent } from './pages/productos/productos.component';
import { AdministracionComponent } from './administrador/administracion/administracion.component';
import { SolicitudesComponent } from './administrador/solicitudes/solicitudes.component';
import { GestionProductosComponent } from './administrador/gestion-productos/gestion-productos.component';
import { NuevoProductoComponent } from './administrador/nuevo-producto/nuevo-producto.component';
import { RegistroComponent } from './pages/registro/registro.component';
import { ClientesComponent } from './administrador/clientes/clientes.component';
import { PedidosComponent } from './pages/pedidos/pedidos.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { EditarProductoComponent } from './administrador/editar-producto/editar-producto.component';
import { ContrasenaComponent } from './pages/contrasena/contrasena.component';


const routes: Routes = [
  { path: 'home', component: InicioComponent},
  { path: 'productos', component: ProductosComponent},
  { path: 'administracion', component: AdministracionComponent},
  { path: 'solicitudes', component: SolicitudesComponent},
  { path: 'GestionProductos', component: GestionProductosComponent},
  { path: 'producto/:id', component: ProductoComponent},
  { path: 'compras', component: ComprasComponent},
  { path: 'nuevoProducto', component: NuevoProductoComponent},
  { path: 'editarProducto/:id', component: EditarProductoComponent},
  { path: 'registro/:id', component: RegistroComponent},
  { path: 'clientes', component: ClientesComponent},
  { path: 'pedidos', component: PedidosComponent},
  { path: 'perfil', component: PerfilComponent},
  { path: 'contrasena', component: ContrasenaComponent},
  { path: '**', pathMatch: 'full', redirectTo: '/productos'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

